import React from "react";
import Row from "react-bootstrap/Row";
import CardProduct from "../../../components/Products/CardProduct/CardProduct";
import { Translation } from "react-i18next";
import { ecommerceService } from "../../../services/ecommerce/EcommerceService"
import { connect } from "react-redux"
import config from "../../../config/config";

class FeaturedProducts extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            isLoaded: false,
            products: [],
            page: 0,
        };
    }

    componentDidMount() {
        const storeId = this.props.cart ? this.props.cart.storeId : null;
        ecommerceService.featuredProducts(storeId, this.state.page).then(response => {
            console.log(response);
            this.setState({
                isLoaded: true,
                products: response.data
            })
        });
    }

    UNSAFE_componentWillReceiveProps(nextProps) {
        const storeId = this.props.cart ? this.props.cart.storeId : null;
        if (nextProps && nextProps.cart) {
            if (storeId !== nextProps.cart.storeId) {
                ecommerceService.featuredProducts(nextProps.cart.storeId, 0).then(response => {
                    this.setState({
                        isLoaded: true,
                        products: response.data
                    })
                });
            }
        } else {
            ecommerceService.featuredProducts(null, 0).then(response => {
                this.setState({
                    isLoaded: true,
                    products: response.data
                })
            });
        }
    }

    loadMore = () => {
        const storeId = this.props.cart ? this.props.cart.storeId : null;
        ecommerceService.featuredProducts(storeId, this.state.page + 1)
            .then(response => {
                const newResponse = this.state.products;
                newResponse.push(...response.data);
                this.setState({
                    isLoaded: true,
                    products: newResponse,
                    page: response.number
                })
            });
    }

    render() {
        const { products, isLoaded } = this.state;
        if (isLoaded) {
            return (
                <Translation>
                    {t =>
                        <div className="search-product-view">
                            <Row className="no-gutters justify-content-center">
                                {products && products.map((item) => (
                                    <CardProduct key={item.id} item={item} />
                                ))}
                            </Row>
                            <div className="text-center">
                                <button className="cta w-25" onClick={this.loadMore}>
                                    <span>{t("loadMore")}</span>
                                </button>
                            </div>
                        </div>
                    }
                </Translation>
            );
        } else {
            return null;
        }
    }
}

const mapStateToProps = state => {
    return {
        cart: state.cart.cart,
    };
}

export default connect(mapStateToProps)(FeaturedProducts);
